
(function appModuleDefinition() {

    angular.module('App')
        .controller('AppController', [
            '$scope', 'auth', 'authExtend', '$state', 'navMenu', 'ui', '$rootScope', 'config', '$location', '$window', 'adminOrganizationalUnitService', '$filter',
            function (scope, auth, authExtend, $state, navMenu, ui, $rootScope, config, $location, $window, adminOrganizationalUnitService, $filter) {

                $rootScope.$on('$stateChangeSuccess', function () {
                    if (config.custom('googleAnalticsKey')) {
                        $window.ga('send', 'pageview', { page: $location.path() });
                    }
                });

                auth.externalRegistrationCallback = function () {
                    $state.go('register');
                };

                scope.onLogin = function (result) {
                    if (result && authExtend.getMustChangePassword()) {
                        $state.go('change-password');
                        return false;
                    }

                    return true;
                }

                scope.ouId = auth.getOrganizationId();

                auth.onIdentityChanged(function () {
                    scope.appOrganizationName = auth.getOrganizationName();
                    //scope.urlOrganizationIcon = auth.getUrlIcon();
                    if (scope.ouId) {
                        adminOrganizationalUnitService.getImagesById(scope.ouId).then(function (result) {
                            if (result) {
                                var logo = $filter('filter')(result, { isLogo: true }, true)[0];
                                scope.urlOrganizationIcon = logo !== undefined ? 'data:image/jpeg;base64,' + logo.base64File : undefined;
                            }
                        });
                    }
                    ui.setTheme(auth.getTheme());
                });

                // esto es para que si se perdió la cookie 
                // no aparezca como que está logueado.
                if (!window.isAuthenticated) {
                    auth.forget();
                }

                // Para que al refrescar no se pierda el nombre de la App.
                scope.appOrganizationName = auth.getOrganizationName();
                //scope.urlOrganizationIcon = auth.getUrlIcon();
                if (scope.ouId) {
                    adminOrganizationalUnitService.getImagesById(scope.ouId).then(function (result) {
                        if (result) {
                            var logo = $filter('filter')(result, { isLogo: true }, true)[0];
                            scope.urlOrganizationIcon = logo !== undefined ? 'data:image/jpeg;base64,' + logo.base64File : undefined;
                        }
                    });
                }

                ui.setTheme(auth.getTheme());
                scope.userNick = auth.getUserNick();

                //ui.setTheme(auth.getTheme());

            }
        ]);

})();